import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useFavoritesStore from '../store/useFavoritesStore';
import ServiceCard from '../components/ServiceCard';

export default function FavoritesPage() {
  const navigate = useNavigate();
  const { favorites, syncFromServer } = useFavoritesStore();

  useEffect(() => { syncFromServer(); }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-dark-bg pb-24">
      <div className="px-4 pt-12 pb-4">
        <div className="flex items-center gap-2 mb-6">
          <h1 className="text-2xl font-bold text-dark-text" style={{ letterSpacing: '-0.5px' }}>Saved</h1>
          {favorites.length > 0 && (
            <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-brand-purple/20 text-brand-purple">
              {favorites.length}
            </span>
          )}
        </div>

        {favorites.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-24 text-center">
            <div className="w-20 h-20 rounded-full bg-dark-surface border border-dark-border flex items-center justify-center mb-5">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-dark-subtext/50">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
            </div>
            <p className="text-dark-text font-semibold text-lg mb-1">No saved services yet</p>
            <p className="text-dark-subtext text-sm mb-6">Tap the heart on any service to save it here.</p>
            <button
              onClick={() => navigate('/explore')}
              className="px-6 py-3 rounded-2xl bg-brand-gradient text-white font-semibold text-sm"
            >
              Explore services
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            {favorites.map(s => <ServiceCard key={s.id} service={s} />)}
          </div>
        )}
      </div>
    </div>
  );
}
